var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEstateAllStep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 69,
    viewBox: "0 0 55 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2159_208)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.00586,
    width: 49,
    height: 62.9881,
    rx: 3.5,
    fill: "#F3F3F3",
    stroke: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.30469,
    y: 38.8955,
    width: 38.3919,
    height: 2.55946,
    rx: 1.27973,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.30469,
    y: 32.0723,
    width: 38.3919,
    height: 2.55946,
    rx: 1.27973,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.30469,
    y: 45.7227,
    width: 38.3919,
    height: 2.55946,
    rx: 1.27973,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.30469,
    y: 52.5508,
    width: 27.3009,
    height: 2.55946,
    rx: 1.27973,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.416 10.9238L34.5839 26.2871",
    stroke: "#DE2B2B",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5841 10.9238L20.416 26.2871",
    stroke: "#DE2B2B",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2159_208",
    x: 0.5,
    y: 0.505859,
    width: 54,
    height: 67.9883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2159_208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2159_208",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstateAllStep2);
export default __webpack_public_path__ + "static/media/IcEstateAllStep2.34b2366e8203da20cb468a4e15f295ad.svg";
export { ForwardRef as ReactComponent };